import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import React from 'react';
import {COLORS} from '@fupa/fupa-uikit';

interface DeleteDialogProps {
  description: string;
  open: boolean;
  onReject: () => void;
  onResolve: () => void;
  title: string;
}

export default function DeleteDialog({open, onReject, onResolve, title, description}: DeleteDialogProps) {
  return (
    <Dialog open={open} aria-labelledby='delete-dialog-title' aria-describedby='delete-dialog-description'>
      <DialogTitle id='delete-dialog-title'>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id='delete-dialog-description'>{description}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant='text' sx={{color: COLORS.darkerGrey}} onClick={onReject}>
          Abbrechen
        </Button>
        <Button variant='contained' color='error' onClick={onResolve} autoFocus>
          Löschen
        </Button>
      </DialogActions>
    </Dialog>
  );
}
